module.exports = __webpack_public_path__ + "static/img/13-广宁.fcd64266.png";